import React from 'react';
import Modal from "../../components/modal/modal";
import styles from "../../styles/main.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faX} from "@fortawesome/free-solid-svg-icons";
import Loading from "../../components/loading/loading";
import { closeFinancingRequest, openFinancingConfirm } from '../bus/modalApi';

export default function RequestFinancingModal({show, setter, quoteData, selectedInvoice}) {

    const parseValue = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const accept = () => {
        closeFinancingRequest();
        openFinancingConfirm({ quoteData, selectedInvoice });
    }

    return (
        <Modal show={show} setter={setter} hideClose={true} size={'lg'}>
            <div style={{textAlign: "center"}}>
                <div style={{fontSize: "20px", color: "#FD425F",}}>¡TIENES UNA OFERTA POR TU FACTURA!</div>
                <div style={{fontSize: "14px", color: "#4A4DBB"}}>Obtén liquidez inmediata de tu factura al crédito</div>
            </div>

            {Object.keys(quoteData).length > 0 ?
                <div className={'d-flex justify-content-between'}>
                    <div>
                        <div>IGV: {parseValue(quoteData.igv)}</div>
                        <div>Total Estimado: {parseValue(quoteData.total_estimated_cost)}</div>
                        <div>TEA: {parseValue(quoteData.tea) * 100}%</div>
                        <div>TCEM: {parseValue(quoteData.tcem) * 100}%</div>
                        <div>TCEA: {parseValue(quoteData.tcea) * 100}%</div>
                        <div>CAT: {parseValue(quoteData.cat)* 100}%</div>
                        <div>Balance estimado neto: {Math.abs(parseValue(quoteData.estimated_net_balance))}</div>
                        <div>Monto: {parseValue(quoteData.amount)}</div>
                        <div>Adelanto neto: {parseValue(quoteData.advance_net)}</div>
                        <div>Estimated funding cost: {parseValue(quoteData.estimated_funding_cost)}</div>
                    </div>
                    <div>
                        <div>Costo de estudio: {parseValue(quoteData.study_cost)}</div>
                        <div>Comisión por colección: {parseValue(quoteData.collection_fee)}</div>
                        <div>Costos operacionales: {parseValue(quoteData.operational_cost)}</div>
                        <div>Adelanto bruto: {parseValue(quoteData.advance_gross)}</div>
                        <div>Comisión: {parseValue(quoteData.facturedo_fee)}</div>
                        <div>Máximo descuento mensual: {parseValue(quoteData.max_monthly_discount_rate)}</div>
                        <div>Descuento mensual bruto: {parseValue(quoteData.gross_monthly_discount_rate)}</div>
                    </div>
                </div>
                :
                <Loading style={{paddingTop: '1rem'}}/>
            }

            <div className={'d-flex justify-content-center align-items-center align-content-center mt-3'}>
                <div onClick={accept} className={styles.modalButton} style={{backgroundColor: "#2F9636"}}>
                    <FontAwesomeIcon icon={faCheck} className={'pe-2'}/> Aceptar
                </div>
                <div onClick={() => setter(false)} className={styles.modalButton} style={{backgroundColor: "#FD425F"}}>
                    <FontAwesomeIcon icon={faX} className={'pe-2'}/> Rechazar
                </div>
            </div>
        </Modal>
    )
}
